<template>
  <div class="container">
    <div
      class="container-for-main-info"
      style="scroll-behavior: smooth"
    >
      <LandingRates
        id="subscriptionPlans"
        grid="1fr"
        display="grid"
      />
      <span id="tariff"></span>
    </div>
    <h3 id="subManagement">
      {{ $t('subManagement') }}
    </h3>
    <p>
      {{ $t('subManagementT1') }}
    </p>
    <p>
      {{ $t('subManagementT2') }}
    </p>
    <h4 class="mb-5">
      {{ $t('activatingSub') }}
    </h4>
    <p>{{ $t('paySubscription') }}</p>
    <UiTextHelpText
      textWarning="important"
      title="automaticallyRenewed"
    />
  </div>
  <h4 class="mb-5">
    {{ $t('cancellingSub') }}
  </h4>
  <p>{{ $t('clickUnsubscribe') }}</p>
</template>
<script lang="ts">
import {onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import DownloadLauncherButton from '~/components/DownloadLauncherButton.vue';
import {useHead, useRuntimeConfig} from '#imports';
import {useDirectionStore} from '~/store/direction.store';
import LandingRates from '~/modules/Landing/components/LandingRates.vue';

export default {
  components: {LandingRates, DownloadLauncherButton},
  setup() {
    const {t} = useI18n();
    const isShowFeedBackModal = ref(false);
    const runtimeConfig = useRuntimeConfig();
    const isDflat =
      runtimeConfig.public.vueAppBaseUrl.includes('d-flat.ru');

    const direction = useDirectionStore();
    const right = computed(() => direction.isRight);
    useHead({
      title: `${t('DreamFlat')} - ${t('plansPayments')}`,
      meta: [
        {
          name: 'description',
          content: `${t('plansHelpMetaDesc')}`,
        },
      ],
    });
    useSeoMeta({
      ogTitle: `${t('DreamFlat')} - ${t('plansPayments')}`,
      description: `${t('plansHelpMetaDesc')}`,
      ogDescription: `${t('plansHelpMetaDesc')}`,
      ogImage: 'https://dreamflat.design/prev.webp',
    });

    return {
      slide: ref(1),
      isShowFeedBackModal,
      isDflat,
      right,
    };
  },
};
</script>
<style lang="scss" scoped>
@import 'css/help-center/help-center-general-ctyle';

.container-for-main-info {
  margin-bottom: $m-13;
}

.help-text {
  margin: $m-6 0px;
}
</style>
